import { Typography } from "antd"
import { useTranslation } from "react-i18next"

import { blockAnchor } from "../../constants"

import styles from "./block.module.less"

const { Text, Title } = Typography

// One block of the page (DAA-1-07): its heading and one-line description, then its cards. The
// section's id is the anchor the right-side navigation scrolls to.
export const Block = ({ block, children }) => {
  const { t } = useTranslation()

  return (
    <section id={blockAnchor(block.id)} className={styles.block}>
      <div className={styles.head} data-intro>
        <Title level={3} style={{ margin: 0 }}>
          {t(block.title)}
        </Title>
        <Text type="secondary">{t(block.description)}</Text>
      </div>
      <div className={styles.grid}>{children}</div>
    </section>
  )
}

// A card's place in its block: a row of its own (DAA-1-08, CHA1-4558).
export const BlockSlot = ({ children }) => <div className={styles.slot}>{children}</div>
